import debugFactory from "debug";
import amplitude from "amplitude-js";

const IS_DEV_ENV = process.env.NODE_ENV === "development";

const debug = debugFactory( "teaming:common-vendor:amplitude" );

const NO_REQUEST_SENT_CODE = 0;
let userProperties = {};
let userId = null;

const delayCache = [];

const event = ( name, eventProperties = {}, ensureUser = false ) => {
	if ( ensureUser && !userId ) {
		return delayCache.push( { name, eventProperties, } );
	}
	if ( IS_DEV_ENV ) {
		return debug( `(${ userId }):`, name, eventProperties, delayCache );
	}
	amplitude.logEvent( name, eventProperties, ( code, message, details ) => {
		// NOTE: unanticipated exceptions are handled by amplitude's internal logging
		if ( code === NO_REQUEST_SENT_CODE ) {
			// eslint-disable-next-line no-console
			console.warn( message, details );
		}
	} );
};

const flushCache = () => {
	let cacheEntry = delayCache.pop();
	while ( cacheEntry ) {
		event( cacheEntry.name, cacheEntry.eventProperties );
		cacheEntry = delayCache.pop();
	}
};

const setAmplitudeUser = user => {
	userProperties = {};
	userId = null;
	if ( user ) {
		userProperties = {
			// eslint-disable-next-line camelcase
			email_address: user.email,
			domain: user.email.replace( /.*@/, "" ),
			...user.props,
		};
		userId = user.email;
	}
	if ( IS_DEV_ENV ) {
		debug( "updated user props", { userId, userProperties, } );
		return flushCache();
	}

	// NOTE: these calls will POST to the amplitude API
	amplitude.setUserId( userId );
	amplitude.setUserProperties( userProperties );
	flushCache();
};

const setUserId = ( email = null ) => {
	userId = email;
	if ( IS_DEV_ENV ) {
		return debug( "updated user ID", { userId, } );
	}
	// NOTE: this call will POST to the amplitude API
	amplitude.setUserId( userId );
};

export default function amplitudeFactory( { amplitudeToken, } ) {
	if ( IS_DEV_ENV ) {
		debug( `init (${ amplitudeToken })` );
	}

	amplitude.getInstance().init( amplitudeToken, null, {
		includeReferrer: true,
		includeUtm: true,
		includeGclid: true,
	} );

	return {
		setAmplitudeUser,
		setUserId,
		event,
	};
}
